import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'EventMarketsSkeleton',
  values: {
    selectionsAmountMask: [
      2,
      2,
      3,
      2,
      2,
    ],
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          _mobile_padding: '8px',
        },
      },
    },
    marketGroupContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 0 8px 8px',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      },
    },
    marketContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          flexDirection: 'column',
          borderRadius: '8px',
        },
      },
    },
    marketSwitcherContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '8px 0 0',
          flexWrap: 'wrap',
          _mobile_flexWrap: 'nowrap',
        },
      },
    },
    marketHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 0 20px 0',
        },
      },
    },
    selectionsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    marketHeaderPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '104px',
          height: '16px',
        },
      },
    },
    selectionPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          flexGrow: 1,
          height: '44px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
